import {
  ListCellsSelectionRoot as DesignListCellsSelectionRoot,
  ListCellsSelectionRootProps,
} from '@bts-web/design-system/component/list-cells-selection';
import { css, cx } from '@bts-web/utils-style-engine';

const ListCellsSelectionRoot = ({
  children,
  onValueChange,
  className,
  ...rest
}: ListCellsSelectionRootProps) => (
  <DesignListCellsSelectionRoot
    className={cx(
      css({
        backgroundColor: 'screen_background.primary',
        display: 'flex',
        flexDirection: 'column',
      }),
      className,
    )}
    onValueChange={onValueChange}
    {...rest}
  >
    {children}
  </DesignListCellsSelectionRoot>
);

export { ListCellsSelectionRoot };
